import * as angular from 'angular';

export class CompanyFactory {
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    readCompany() {
        return this.$http.get(`/api/v2/me/`);
    }
}

angular
    .module('app')
    .service('CompanyFactory', CompanyFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/company.factory.ts